import React from 'react';
import { FaTrophy, FaMedal, FaCertificate } from 'react-icons/fa';
import { Icon } from '@iconify/react';
import mckinseyIcon from "../images/mckinsey.png";




const Achievements: React.FC = () => {
    const awards = [

        {
            title: "Finalist, 18th BCSWomen Lovelace Colloquium (2025)",
            description: "Selected as one of 150+ student finalists nationwide, acknowledged for innovation, technical skill, and contributions to the field of computing.",
            icon: <FaMedal className="achievements-icon" />,
            type: "recognition"
        },
        {
            title: "Certificate of Achievement - Gold Student Representative (2025)",
            description: "Received at the Student Experience Awards in recognition of leadership and active engagement in student representation.",
            icon: <FaCertificate className="achievements-icon" />,
            type: "leadership"
        },
        {
            title: "Dean’s Award for Academic Excellence (2021/22)",
            description: "Achieved an aggregate mark of 70% and higher.",
            icon: <FaTrophy className="achievements-icon" />,
            type: "academic"
        },
    ];

    const certifications = [
        {
            title: "McKinsey Forward Program",
            description: "McKinsey & Company, 2026",
            icon: <img src={mckinseyIcon} alt="McKinsey & Company" width={30} height={30} className="skills-icon" />,
            type: "certification"
        },
        {
            title: "Node-RED Advanced",
            description: "Node-RED Academy / FlowFuse, 2026",
            icon: <Icon icon="devicon:nodered" height="0.4em" className="skills-icon" />,
            type: "certification"
        },
        {
            title: "Node-RED Fundamentals",
            description: "Node-RED Academy / FlowFuse, 2026",
            icon: <Icon icon="devicon:nodered" height="0.4em" className="skills-icon" />,
            type: "certification"
        }
    ];

    return (
        <div className="achievements container">
            <div className="title-box text-center">
                <h1 className="title-a">Awards</h1>
            </div>
            <div className="achievements-grid">
                {awards.map((award, idx) => (
                    <div key={idx} className={`achievements-card ${award.type}`}>
                        <div className="achievements-header">
                            {award.icon}
                            <h3 className="achievements-title">{award.title}</h3>
                        </div>
                        <p className="achievements-description">{award.description}</p>
                    </div>
                ))}
            </div>
            <div className="title-box text-center">
                <h1 className="title-a">Certifications</h1>
            </div>

            <div className="achievements-grid">
                {certifications.map((cert, idx) => (
                    <div key={idx} className={`achievements-card ${cert.type}`}>
                        <div className="achievements-header">
                            {cert.icon}
                            <h3 className="achievements-title">{cert.title}</h3>
                        </div>
                        <p className="achievements-description">{cert.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Achievements;
